export default __webpack_public_path__ + "static/media/logo-clean.f1cd9bd5.png";